import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReportMarkdown } from './ReportMarkdown.js';
import styles from './HowItWorks.module.css';

interface Props {
  /** Mini App flows-namespace key prefix for this tool. */
  toolKey: 'ask' | 'when' | 'lucky' | 'check';
}

export function HowItWorks({ toolKey }: Props): JSX.Element {
  const { t } = useTranslation('flows');
  const [open, setOpen] = useState(false);
  const title = t(`${toolKey}.tips.title`);
  const body = t(`${toolKey}.tips.body`);
  return (
    <div className={styles.wrap} data-testid={`how-it-works-${toolKey}`}>
      <button
        type="button"
        className={styles.header}
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        data-testid={`how-it-works-toggle-${toolKey}`}
      >
        <span className={styles.title}>{title}</span>
        <span className={styles.chevron} aria-hidden="true">{open ? '▾' : '▸'}</span>
      </button>
      {open && (
        <div className={styles.body} data-testid={`how-it-works-body-${toolKey}`}>
          <ReportMarkdown markdown={body} />
        </div>
      )}
    </div>
  );
}
